import {Box, Typography} from '@mui/material';
import React from 'react';
import AurSearchBox from '../../../../common/aur-search-box/AurSearchBox';
import {t} from 'i18next';

export interface IQueryFieldSearchDrawerProps {
  title?: string;
  children?: React.ReactNode;
  onSearch?: ((keyword: string) => void);
}

const QueryFieldSearchDrawer: React.FC<IQueryFieldSearchDrawerProps> = ({
  title,
  children,
  onSearch,
}) => {
  return (
    <Box className={'query-field-search-field-container'}>
      {title && (
        <Typography
          className="typo-text body2_size color-mist-1300"
          aria-label={title}
        >
          {title}
        </Typography>
      )}
      {children ?? null}
      <AurSearchBox
        classNameProps={'search-field-textfield'}
        variant={'outlined'}
        label={''}
        placeHolder={t('common.search')}
        hintText={t('indexSearchPage.accessibilityLabel.searchMetadata')}
        onSearch={onSearch}
      />
    </Box>
  );
};

export {QueryFieldSearchDrawer};
